import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

interface LayoutProps {
  children: ReactNode;
}

/**
 * SPLICEWebサイト基本レイアウトコンポーネント
 * 全ページで共通のレイアウト構造を提供
 */
const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const isIndexPage = location.pathname === '/';

  return (
    <div className="d-flex flex-column min-vh-100" style={{ backgroundColor: 'var(--color-bg-body)' }}>
      <div className={`wrapper container-fluid p-0 mx-auto d-flex flex-column flex-grow-1 ${!isIndexPage ? 'bg-white' : ''}`}>
        {/* ヘッダー・ナビゲーション */}
        <div className="bg-white">
          <Header />
        </div>

        {/* メインコンテンツエリア */}
        <main className={`flex-grow-1 ${!isIndexPage ? 'bg-white' : ''}`}>
          {children}
        </main>

        {/* フッター */}
        <div className="bg-white">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Layout; 